import React from 'react';
import {
  Box,
  Fab,
  Tooltip,
  Zoom,
} from '@mui/material';
import {
  WhatsApp,
  Email,
} from '@mui/icons-material';

// Custom SVG icons for social media platforms
const FacebookIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const TikTokIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const SocialMediaFloatButtons = () => {
  // Social media links - Update these with your actual social media URLs
  const socialLinks = {
    whatsapp: 'https://wa.me/256754577922',
    email: 'mailto:stuartkevinz852@gmail.com?subject=Inquiry from CarryIT Rentals Website',
    facebook: 'https://www.facebook.com/easyrentals', // Update with your Facebook page URL
    instagram: 'https://www.instagram.com/easyrentals', // Update with your Instagram page URL
    tiktok: 'https://www.tiktok.com/@easyrentals', // Update with your TikTok page URL
  };

  const handleClick = (url, isEmail = false) => {
    if (isEmail) {
      window.location.href = url;
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  const buttons = [
    {
      name: 'WhatsApp',
      icon: <WhatsApp sx={{ fontSize: 24 }} />,
      color: '#25D366',
      url: socialLinks.whatsapp,
      tooltip: 'Chat with us on WhatsApp',
    },
    {
      name: 'Email',
      icon: <Email sx={{ fontSize: 24 }} />,
      color: '#EA4335',
      url: socialLinks.email,
      tooltip: 'Send us an email',
      isEmail: true,
    },
    {
      name: 'Facebook',
      icon: <FacebookIcon />,
      color: '#1877F2',
      url: socialLinks.facebook,
      tooltip: 'Visit our Facebook page',
    },
    {
      name: 'Instagram',
      icon: <InstagramIcon />,
      color: '#E4405F',
      url: socialLinks.instagram,
      tooltip: 'Follow us on Instagram',
    },
    {
      name: 'TikTok',
      icon: <TikTokIcon />,
      color: '#000000',
      url: socialLinks.tiktok,
      tooltip: 'Follow us on TikTok',
    },
  ];

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: { xs: 16, sm: 24 },
        right: { xs: 16, sm: 24 },
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 1, sm: 1.5 },
        alignItems: 'center',
      }}
    >
      {buttons.map((button, index) => (
        <Zoom
          key={button.name}
          in={true}
          timeout={300 + index * 100}
          style={{
            transitionDelay: `${index * 100}ms`,
          }}
        >
          <Tooltip
            title={button.tooltip}
            placement="left"
            arrow
          >
            <Fab
              size="medium"
              sx={{
                bgcolor: button.color,
                color: 'white',
                width: { xs: 52, sm: 56 },
                height: { xs: 52, sm: 56 },
                boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  bgcolor: button.color,
                  transform: 'scale(1.1)',
                  boxShadow: '0 6px 25px rgba(0,0,0,0.3)',
                },
                '&:active': {
                  transform: 'scale(0.95)',
                },
              }}
              onClick={() => handleClick(button.url, button.isEmail)}
              aria-label={button.name}
            >
              {button.icon}
            </Fab>
          </Tooltip>
        </Zoom>
      ))}
    </Box>
  );
};

export default SocialMediaFloatButtons;

